import { collection, doc, addDoc, getDoc, getDocs, updateDoc, query, where, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';

export async function createTicket({ tripId, bookingId, submittedBy, submitterRole, category, description, attachments }) {
  const fn = httpsCallable(functions, 'createSupportTicket');
  return (await fn({ tripId, bookingId, submittedBy, submitterRole, category, description, attachments })).data;
}

export async function getMyTickets(userId) {
  const q = query(collection(db, 'tickets'), where('submittedBy', '==', userId), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getTicket(ticketId) {
  const snap = await getDoc(doc(db, 'tickets', ticketId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function addTicketResponse(ticketId, responderId, responderRole, message) {
  return addDoc(collection(db, 'tickets', ticketId, 'responses'), {
    responderId, responderRole, message, createdAt: serverTimestamp(),
  });
}

export async function getTicketResponses(ticketId) {
  const q = query(collection(db, 'tickets', ticketId, 'responses'), orderBy('createdAt', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function submitSatisfactionRating(ticketId, satisfied, comment = '') {
  await updateDoc(doc(db, 'tickets', ticketId), {
    satisfactionRating: { satisfied, comment, ratedAt: new Date().toISOString() },
    updatedAt: serverTimestamp(),
  });
}
